"use client";

import { cn } from "../../../../utils";
import type { TableRowType } from "../../Table.types";
import { getDefaultCardId } from "../../Table.utils";
import { TableSkeletonLoading } from "../TableSkeletonLoading";
import { TableMobileProps } from "./Table.types.mobile";
import { TableCardMobile } from "./TableCard.mobile";

export const TableMobile = <
  Row extends TableRowType,
  Group extends string = never,
>(
  props: TableMobileProps<Row, Group>,
) => {
  const {
    data,
    classes,
    isLoading,
    emptyState,
    openCardIds,
    defaultSkeletonRowCount,
    getCardId = getDefaultCardId,
    renderMobileCard,
    ...rest
  } = props;

  if (!renderMobileCard) return null;

  return (
    <div
      className={cn(
        "ui:w-full ui:bg-white ui:dark:bg-background",
        classes?.wrapper,
      )}
    >
      <div className={cn("ui:flex ui:flex-col ui:gap-3", classes?.table)}>
        {!isLoading && data.length === 0 && emptyState}

        {isLoading ? (
          <TableSkeletonLoading
            wrapperClassName={classes?.loading?.wrapper}
            skeletonClassName={classes?.loading?.skeleton}
            dataLength={defaultSkeletonRowCount ?? data.length}
          />
        ) : (
          data.map((row, cardIndex) => {
            const cardId = getCardId(row, cardIndex);
            const isCardOpen = openCardIds?.includes(cardId) ?? false;

            return (
              <TableCardMobile<Row, Group>
                {...rest}
                row={row}
                key={cardId}
                cardId={cardId}
                classes={classes}
                isOpen={isCardOpen}
                cardIndex={cardIndex}
                renderMobileCard={renderMobileCard}
              />
            );
          })
        )}
      </div>
    </div>
  );
};
